import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import moment from 'moment';
import { Divider, Stack, Typography } from '@mui/material';
import QuestionForm from '../pages/form';
import { toast } from 'react-hot-toast';
import { fetchWith401Check } from '../helpers/http';
import Cookies from 'universal-cookie';
import { decode } from 'jsonwebtoken';
import _ from 'lodash';

export default function DialogQuestions({ open, handleOk, handleClose, metadata, userInfo }) {
  const [loadingState, setLoadingState] = React.useState({});
  const [trackChange, setTrackChange] = React.useState({});

  const API_URL = process.env.REACT_APP_STAGE === 'DEVELOPMENT' ? process.env.REACT_APP_API_HOST : process.env.REACT_APP_API_HOST_PROD;

  const cookies = new Cookies();
  const decoded = decode(cookies.get('token'));
  const getTrackChange = () => {
    if (!metadata.id) return;
    setLoadingState({ ...loadingState, trackchange: true });
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.get('token')}` },
    };
    fetchWith401Check(`${API_URL}/tabledatas/trackchange/${metadata.id}`, requestOptions)
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }
        return Promise.reject(response);
      })
      .then(function (response) {
        if (response?.status == 200) {
          setTrackChange(response?.response);
        }
      })
      .catch(function (err) {
        return toast.error(err.message);
      })
      .finally(function () {
        setLoadingState({ ...loadingState, trackchange: false });
      });
  };

  React.useEffect(() => {
    getTrackChange(metadata.id);
  }, [metadata.id]);
  return (
    <div>
      <Dialog maxWidth='lg' open={open} onClose={handleClose} aria-labelledby='alert-dialog-title' aria-describedby='alert-dialog-description'>
        <DialogTitle id='alert-dialog-title'>
          Perubahan - <i>Track Change</i>
        </DialogTitle>
        <DialogContent>
          <Stack direction='column' spacing={2}>
            <Stack direction='row' spacing={1}>
              <Typography variant='body2'>{metadata.id}</Typography>
              <Divider flexItem orientation='vertical' />
              <Typography variant='body2'>
                {metadata?.User?.username} - ({metadata?.User?.type})
              </Typography>

              <Divider flexItem orientation='vertical' />
              <Typography variant='body2'>
                <b>{metadata?.type}</b> - {moment(metadata?.createdAt).format('YYYY-MM-DD HH:mm:ss')}
              </Typography>
            </Stack>
            <Stack sx={{ flex: 2, overflow: 'scroll' }}>
              {!_.isEmpty(trackChange) && (
                <QuestionForm type='trackChange' userInfo={userInfo} metadata={trackChange?.data[1]} fetchedAnswers={trackChange?.data[0] || {}} />
              )}
            </Stack>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>OK</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
